module.exports = __webpack_public_path__ + "static/media/chevron-down-filter-gs.e25b498b.svg";